const LOCAL_SECTIONS = new Set([
  'overview',
  'identity',
  'knowledge',
  'handoff',
  'publication',
  'activity',
  'test',
]);

const SECTION_ALIASES = {
  approvals: 'activity',
  channels: 'publication',
  instructions: 'identity',
  runtime: 'activity',
  scenarios: 'knowledge',
  testing: 'test',
  tools: 'knowledge',
};

const ISSUE_TARGETS = {
  identity: { section: 'identity', fieldId: 'agent-name' },
  instructions: {
    section: 'identity',
    fieldId: 'agent-response-guidelines',
  },
  channel: {
    section: 'publication',
    fieldId: 'agent-connected-channels',
  },
  rollout: {
    section: 'publication',
    fieldId: 'agent-rollout-percent',
  },
  scenario_tools: {
    section: 'knowledge',
    fieldId: 'agent-source-scenarios',
  },
  approval_runtime: {
    section: 'knowledge',
    fieldId: 'agent-source-tools',
  },
  knowledge: { section: 'knowledge', fieldId: 'agent-knowledge' },
  handoff: { section: 'handoff', fieldId: 'agent-default-handoff' },
  tested: { section: 'test', fieldId: '' },
};

const isRecord = value =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const normalizeSection = value => {
  const section = String(value || '').trim();
  const normalized = SECTION_ALIASES[section] || section;
  return LOCAL_SECTIONS.has(normalized) ? normalized : '';
};

const normalizeIssue = issue => {
  if (!isRecord(issue)) return null;

  const key = String(issue.key || '').trim();
  const mappedTarget = ISSUE_TARGETS[key] || {};
  const section = normalizeSection(issue.section) || mappedTarget.section;
  const message = String(issue.message || '').trim();
  if (!key || !section || !message) return null;

  const fieldId =
    !mappedTarget.section || mappedTarget.section === section
      ? mappedTarget.fieldId
      : `agent-${section}`;

  return {
    key,
    section,
    message,
    fieldId: fieldId || `agent-${section}`,
  };
};

const normalizeIssues = issues =>
  Array.isArray(issues) ? issues.map(normalizeIssue).filter(Boolean) : [];

export const readPublicationPreflightError = error => {
  const data = error?.response?.data || error?.apiData;
  if (
    !isRecord(data) ||
    data.error !== 'publication_preflight_failed' ||
    !isRecord(data.readiness)
  ) {
    return null;
  }

  return {
    blockers: normalizeIssues(data.readiness.blockers),
    warnings: normalizeIssues(data.readiness.warnings),
  };
};

export const publicationIssueTarget = issue => {
  const normalizedIssue = normalizeIssue(issue);
  if (!normalizedIssue) {
    return { section: 'publication', fieldId: 'agent-publication' };
  }

  return {
    section: normalizedIssue.section,
    fieldId: normalizedIssue.fieldId,
  };
};
